import React, { useState, useEffect, useContext, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import Topbar from './topbar';
import Sidebar from './sidebar';
import NuevaVenta from 'App/Emitidos/NuevaVenta';
import CargarArchivo from 'App/Emitidos/CargarArchivo';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Typography } from '@material-ui/core';
import { LayoutContext, tdloaded } from 'App/Layout/store'
import { TareasContext } from 'App/Tareas/store'
import axios from 'axios';
import { useAuth } from "react-oidc-context";
import Alert from 'App/components/Alert';
import PollHub from "PollHub";
import MostrarUsuario from 'App/components/MostrarUsuario';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import moment from 'moment';
import MostrarEmpresas from 'App/components/MostrarEmpresas';
import AgregarEditarLibro from "App/components/AgregarEditarLibro";
import RespuestaComercial from 'App/components/RespuestaComercial';
import Cookies from 'universal-cookie';
import oidcConfiguration from '../../oidcConfig';
import _ from 'underscore'
import { GetTags } from "App/Layout/Actions";

const styles = theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: 'calc(100vh - 64px)',
    overflow: 'auto',
    marginTop: '64px'
  },
  appBarSpacer: theme.mixins.toolbar,
  yellowColor: {
    color: "#EEC131"
  }
});

const axiosStateGlobal = {}

function AppLayout(props) {
  const [showSidebar, toggleSidebar] = useState(false);
  const [title, changeTitle] = useState("");
  const { classes } = props;
  const [connecting, setConnecting] = useState(false);
  const layoutContext = useContext(LayoutContext);
  const auth = useAuth();
  const tareasContext = useContext(TareasContext);
  const cookies = new Cookies();
  const [axiosState, setAxiosState] = useState({ ok: false })

  useEffect(() => {
    const handleCambiaTarea = datos => tareasContext.dispatch({ type: 'cambiaTarea', datos });
    const handleDTE = datos => layoutContext.dispatch({ type: 'actualizaDte', datos });
    const handleRCV = datos => layoutContext.dispatch({ type: 'actualizaRcv', datos });
    const handleDTENuevo = (cant, tipo) => layoutContext.dispatch({ type: 'actualizaDteNuevo', cant, tipo });

    PollHub.Connection.on('CambiaTarea', handleCambiaTarea);
    PollHub.Connection.on('DTE', handleDTE);
    PollHub.Connection.on('RCV', handleRCV);
    PollHub.Connection.on('DTENuevo', handleDTENuevo);

    return () => {
      PollHub.Connection.off('CambiaTarea', handleCambiaTarea);
      PollHub.Connection.off('DTE', handleDTE);
      PollHub.Connection.off('RCV', handleRCV);
      PollHub.Connection.off('DTENuevo', handleDTENuevo);
    };
  }, [layoutContext.dispatch, tareasContext.dispatch]);

  const esSeguro = window.location.pathname.toLowerCase().startsWith('/administracion')
  || window.location.pathname.toLowerCase().startsWith('/emitidos')
  || window.location.pathname.toLowerCase().startsWith('/recibidos')
  || window.location.pathname.toLowerCase().startsWith('/documentos')
  || window.location.pathname.toLowerCase().startsWith('/libros')
  || window.location.pathname.toLowerCase().startsWith('/tareas');

  //Carga los tipos de doc
  useEffect(() => {
    if (!auth.isLoading) {
      var oidcStorage = localStorage.getItem(`oidc.user:${oidcConfiguration.authority}:${oidcConfiguration.client_id}`)
      if (!auth.isAuthenticated) {
        if(oidcStorage){
          auth.signinSilent().catch(async e => {
            setTimeout(async()=>await auth.signinRedirect(),2000)
          });
        }else if(esSeguro){
          window.location = ""
        }
      }
      if (auth.isAuthenticated && !axiosState.ok) { // Si hay usuario
        SetAxios()

        if (!connecting) {//Sólo una vez
          setConnecting(true);
          PollHub.startPollHub();
          PollHub.Connection.onclose(() => {
            PollHub.startPollHub()
          })
        }
        if (!tdloaded.current && layoutContext.state.tiposDoc.length == 0) {
          axios.get("/api/tiposdoc").then(tiposDoc => {
            if (tiposDoc && tiposDoc.length > 0) {
              layoutContext.dispatch({ type: "setTiposDoc", tiposDoc });
            }
          }).catch(e => tdloaded.current = false);
          GetTags(layoutContext.dispatch)
          axios.get("/api/Empresa").then(datosEmpresa => {
            layoutContext.dispatch({ type: "setDatosEmpresa", datosEmpresa });
          }).catch(e => console.error(e));
          if(layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre == "Tareas" && p.BLectura)){
            axios.get("/api/Tarea/Corriendo").then(data => {
              tareasContext.dispatch({ type: "setTareasCorriendo", data });
            }).catch(e => console.error(e));
        }
          if (!layoutContext.state.impuestosAdicionales.length) {
            axios.get("/api/DTE/Impuesto").then(impuestosAdicionales => {
              layoutContext.dispatch({ type: "setImpuestosAdicionales", impuestosAdicionales });
            }).catch(e => console.error(e));
          }
          /* if (!layoutContext.state.regiones.length) {
            axios.get("/api/Generico/Region").then(regiones => {
              layoutContext.dispatch({ type: "setRegiones", regiones });
            });
          } */
        }
      } else {
        if (PollHub.Connection.state != 4) {
          PollHub.stopPollHub();
        }
      }
    }
  }, [auth.isAuthenticated, axiosState.ok, auth.isLoading])

  useEffect(() => {
    return auth.events.addUserLoaded((user) => {
      if (!auth.isLoading && auth.isAuthenticated) {
        axiosStateGlobal.token = user?.access_token || auth.user?.access_token;
        SetAxios();
      }
    });
  }, [auth.events, auth.isLoading, auth.isAuthenticated]);

  useEffect(() => {
    return auth.events.addAccessTokenExpired(() => {
      console.warn("[Auth] Access token expired. Attempting silent renew...");
      auth.signinSilent().catch(e => {
        console.error("[Auth] Silent renew after token expiration failed:", e);
      });
    });
  }, [auth.events, auth.signinSilent]);

  useEffect(() => {
    return auth.events.addSilentRenewError((error) => {
      console.warn("[Auth] Silent renew error:", error);
    });
  }, [auth.events]);

useEffect(()=>{
  for (const k of Object.keys(axiosState)) {
    if (k in axiosState) {
      axiosStateGlobal[k] = axiosState[k];
    }
  }
  axiosStateGlobal.token = auth.user?.access_token
},[axiosState, auth.user?.access_token])

  function SetAxios() {
    var oldid = axiosStateGlobal.id*1
    var id = axios.interceptors.request.use(function (config) {
        try {
          var empresa = cookies.get('empresa');
          if (empresa) {
            config.url = config.url.replace("\/api\/", "/api/" + empresa + "/");
          }
          if (config.headers.Authorization != `Bearer ${axiosStateGlobal.token}`) {
            config.headers.Authorization = '';
            delete config.headers.Authorization;
            config.headers.Authorization = `Bearer ${axiosStateGlobal.token}`;
          }
          if(!axiosStateGlobal.ok) setAxiosState({...axiosStateGlobal, ok:true})
          return config;
        } catch(error){
          setAxiosState({ ok: false, id: undefined })
          return Promise.reject("No hay un usuario registrado");
        }
    }, function (error) {
      setAxiosState({ ok: false, id: undefined })
      return Promise.reject(error);
    });
    setAxiosState({ ...axiosStateGlobal, id })
    if (oldid >= 0) {
      axios.interceptors.request.eject(oldid);
    }
  }

  const handleToggleSidebar = useCallback(() => {
    toggleSidebar(prev => !prev);
  }, []);

  const handleTitleChange = useCallback((newTitle) => {
    changeTitle(newTitle);
  }, []);

  const childrenWithProps = React.Children.map(props.children, child =>
    React.cloneElement(child, { ...child.props, titleChange: handleTitleChange })
  );

  switch (auth.activeNavigator) {
    case "signoutRedirect":
      return <div>Saliendo...</div>;
  }

  if (auth.error) {
    setTimeout(async()=>await auth.signinRedirect(),2000)
    return <div>Ocurrió un error: {auth.error.message}.<br />Redirigiendo... </div>;
  }
  if (auth.isLoading && !auth.isAuthenticated) {
    return <div>Cargando... </div>;
  }

  if(auth.isAuthenticated && !layoutContext.state.datosEmpresa) return null;

  return (!auth.isAuthenticated && localStorage.getItem(`oidc.user:${oidcConfiguration.authority}:${oidcConfiguration.client_id}`))?null:(
    <div className={classes.root}>
      <MuiThemeProvider theme={() => createMuiTheme({
        overrides: {
          MuiAppBar: {
            colorPrimary: {
              backgroundColor: '#363636',
            },
          },
          Link: {
            root: {
              color: '#363636',
            }
          }
        }
      })}>
        <CssBaseline />
        <Topbar title={title} showSidebar={showSidebar} toggleSidebar={handleToggleSidebar} />
        {auth.isAuthenticated && <Sidebar showSidebar={showSidebar} toggleSidebar={handleToggleSidebar} changeTitle={handleTitleChange} />}
        <main className={classes.content} /* style={{ margin: 8 }} */>
          {!auth.isAuthenticated && !esSeguro || axiosState.ok ? childrenWithProps : null}
          {auth.isAuthenticated && <p>
            <Typography variant="body2">
              <small>{moment().format('YYYY')} - Sistema de Facturación Electrónica - <a className={classes.yellowColor} href="https://www.asyntec.com" target="_blank">Asyntec SpA</a></small>
            </Typography>
          </p>}
          <NuevaVenta />
          <CargarArchivo />
          <Alert />
          <MostrarUsuario />
          <MostrarEmpresas />
          <AgregarEditarLibro />
          <RespuestaComercial />
        </main>
      </MuiThemeProvider>
    </div>)
}

const LayoutSilent = (props)=>{
  const auth = useAuth();
  if(window.self !== window.top) return null
  return <AppLayout {...props}/>
}

export default withRouter(withStyles(styles)(LayoutSilent));